var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-page"}},[_c('header',{staticClass:"header-search"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"sixteen"},[_c('p',[_vm._v(_vm._s(_vm.$t("LocationDenied")))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }